import EventExplorer from "@/pages/events/components/EventExplorer";

export default function Events() {
  return <EventExplorer />;
}